<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title class="background">
        {{ isAdd ? "Add" : "Edit" }} anonymous feedback
        <span class="primary--text ml-1">(optional)</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-textarea
            flat
            solo
            v-model="question.feedback"
            label="Write your feedback on this question (optional)"
            :rules="[$rules.required]"
            rows="5"
          >
          </v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-row dense>
            <v-col class="secondarytext--text">
              <v-icon color="secondarytext">info</v-icon>
              We'll hide your identity when we share this feedback with company
              admins
            </v-col>
            <v-spacer class="limited-spacer"></v-spacer>
            <v-col cols="auto">
              <v-btn color="performance" :loading="saving" @click="save">
                {{ isAdd ? "Add" : "Edit" }} Feedback
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditFeedbackDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    question: {},
    isAdd: true
  }),
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.question);
        this.dialog = false;
      }
    },
    showDialog(question) {
      this.dialog = true;
      this.isAdd = question.feedback == null;
      this.question = Object.assign({}, question);
    }
  }
};
</script>
